import React from "react";
import { getVisitorId, getSessionId } from "utils/engagementIds";

const useEngagementIds = () => {
	const ids = React.useMemo(() => {
		return {
			al_vid: getVisitorId(),
			al_sid: getSessionId(),
		};
	}, []);

	return ids;
};

export default useEngagementIds;
